// Source UNIQUE du droit "voit / peut créer du bijoux".
//
// Règle (rôle, indépendante du client courant) :
//   - admin                       → true
//   - prefs pas encore lues       → false (conservateur)
//   - user-client                 → false
//   - manager retail (N1/N2…)     → false
//   - serverRetailRole 'internal' → true ; sinon false
//
// Conséquence : seuls admin et internal voient/créent du bijoux. Tous les autres
// (N1, N2, client, scopes retail) ne voient QUE le retail. Utilisé pour masquer
// l'Accueil, la création de commande bijoux et l'onglet "Informations" de la fiche
// client (cf. useHome, CustomerDetail, Customers, useSales.canCreateBijouxOrder,
// useIsRetailOnly.showJewelryCatalog).

import usePrefStore from '../stores/prefs'
import type { RetailRole } from '../types'

export function computeCanSeeJewelry(
   retailRole: RetailRole,
   serverRetailRole: RetailRole,
   isRetailManager: boolean,
   prefsLoaded: boolean,
): boolean {
   if (retailRole === 'admin') return true
   if (!prefsLoaded) return false
   if (serverRetailRole === 'client') return false
   if (isRetailManager) return false
   return serverRetailRole === 'internal'
}

/** Hook réactif : le user courant a-t-il accès au bijoux (sinon = retail-only). */
export default function useCanSeeJewelry(): boolean {
   const retailRole = usePrefStore((s) => s.retailRole)
   const serverRetailRole = usePrefStore((s) => s.serverRetailRole)
   const isRetailManager = usePrefStore((s) => s.isRetailManager)
   const prefsLoaded = usePrefStore((s) => s.prefsLoaded)
   return computeCanSeeJewelry(retailRole, serverRetailRole, isRetailManager, prefsLoaded)
}
